<template>
    <li class="nav-item">
        <a class="nav-link" :href="href" target="_blank" role="button">
            <slot></slot>
        </a>
    </li>
</template>

<script>
export default {
    name: "NavItem",
    props: {
        href: {
            type: String,
            required: true,
            default: ""
        }
    }
}
</script>

<style lang="scss" scoped>
.nav-item {
    border: none;
    color: $text-color !important;
    padding-left: 10px;
    padding-right: 10px;
    font-family: 'Noto Serif SC', serif;
    font-weight: 400;


    &:hover, &:hover > * {
            cursor: pointer;
            color: $primary-dark !important;
            text-decoration: none
        }

    a {
        text-align: center;
        text-transform: capitalize;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: $text-color !important;
    }
}


@media (max-width: 1199.98px) {
    .nav-link {
        font-size: 12px !important;
    }
}

@media (max-width: 991.98px) {
    .nav-item {
        padding: 0.75rem 0 0.75rem 0.75rem;
        border-bottom: 1px solid $primary-color;
        width: 100%;
    }

    .nav-item .nav-link {
        font-size: 14px !important;
        color: $white !important;
        padding: 0;
    }
}
</style>
